import { Grid, TableCell, TableRow } from '@mui/material';
import React from 'react';

const ExpandedJuegosComponent = ({ data, rowData }) => {
  return (
    <TableRow>
      <TableCell colSpan={rowData.length} sx={{ p: 2 }}>
        <Grid container>
          <Grid item xs={12} md={4} align="center">
            <strong>Descripción:</strong>
            <br />
            {data.desc || 'Sin descripción'}
          </Grid>
          <Grid item xs={12} md={4} align="center">
            <strong>Fecha de creación:</strong>
            <br />
            {data.createdAt}
            <br />
            <strong>Fecha de edición:</strong>
            <br />
            {data.updatedAt}
          </Grid>
        </Grid>
      </TableCell>
    </TableRow>
  );
};

export default ExpandedJuegosComponent;
